import { useState } from "react";

import loadjs from "shared/util/loadjs";
import { isMobile } from "shared/util/EnvironmentHelpers";

const KRUX_API_ID = isMobile ? "qvd051dz1" : "qvd044n1c";
const KRUX_SDK_URL = `https://cdn.krxd.net/controltag/${KRUX_API_ID}.js`;

const initKruxTracking = (kruxData) => {
	window.KruxData = kruxData;
	const Krux = window.Krux || (((...args) => { Krux.q.push(args); }).q = []);

	function retrieve(n) {
		let m; const k = `_kx${n}`; const
			ls = (() => {
				try {
					return window.localStorage;
				} catch (e) {
					return null;
				}
			})();

		if (ls) {
			return ls[k] || "";
		} else if (navigator.cookieEnabled) {
			m = document.cookie.match(`${k}=([^;]*)`);
			return (m && unescape(m[1])) || "";
		} else {
			return "";
		}
	}

	Krux.user = retrieve("user");
	Krux.segments = retrieve("segs") ? retrieve("segs").split(",") : [];

	// DFP Premium Interchange
	const dfpp = [];

	if (Krux.user) {
		dfpp.push(`kuid=${Krux.user}`);
	}

	Krux.segments.forEach((segment) => dfpp.push(`ksg=${segment}`));
	Krux.dfppKeyValues = dfpp.length ? `${dfpp.join(";")};` : "";
};

function useKruxTracking({ adFree, kruxData }) {
	const [hasLoaded, setHasLoaded] = useState(false);

	if (!adFree && !hasLoaded) {
		initKruxTracking(kruxData);
		loadjs(KRUX_SDK_URL, {
			className: "kxct",
			"data-id": KRUX_API_ID,
			"data-timing": "async",
			"data-version": "3.0",
		});
		setHasLoaded(true);
	}
}

export default useKruxTracking;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useKruxTracking.js